// Наборы значений статьи, общие для сайта, админки и сервера. Объявлены один раз: копия в любой из
// трёх сторон разошлась бы с остальными молча — сайт отбирал бы статьи по группе, которую админка
// не предлагает, а сервер принимал бы то, чего сайт не покажет.

// Тематическая группа блога: по ней сайт собирает список и отбирает статьи.
export enum EArticleGroup {
    StairType = 'stair-type',
    Room = 'room',
    Opening = 'opening',
    Stair = 'stair',
    Railing = 'railing',
    Materials = 'materials',
    Result = 'result',
}

// Язык статьи — один из языков сборки сайта.
export enum EArticleLocale {
    Ru = 'ru',
    En = 'en',
    Fr = 'fr',
    De = 'de',
}

// Вид блока статьи: сайт по нему выбирает, как показать блок, редактор — какие поля предложить.
export enum EArticleBlockKind {
    Paragraph = 'paragraph',
    Heading = 'heading',
    List = 'list',
    Callout = 'callout',
    Image = 'image',
    Quote = 'quote',
    Embed = 'embed',
    Button = 'button',
    ProsCons = 'pros-cons',
    Accordion = 'accordion',
}

export const ARTICLE_GROUPS: readonly EArticleGroup[] = Object.values(EArticleGroup);
export const ARTICLE_LOCALES: readonly EArticleLocale[] = Object.values(EArticleLocale);

// Названия языков — каждый своим именем, как его узнаёт говорящий на нём.
export const ARTICLE_LOCALE_TITLES: Readonly<Record<EArticleLocale, string>> = {
    [EArticleLocale.Ru]: 'Русский',
    [EArticleLocale.En]: 'English',
    [EArticleLocale.Fr]: 'Français',
    [EArticleLocale.De]: 'Deutsch',
};

const GROUP_VALUES: ReadonlySet<string> = new Set<string>(ARTICLE_GROUPS);
const LOCALE_VALUES: ReadonlySet<string> = new Set<string>(ARTICLE_LOCALES);

// Проверка значения, пришедшего строкой снаружи. Что делать с непрошедшим, решает вызывающий:
// сервер отказывает, экран берёт умолчание.
export function isArticleGroup(value: string): value is EArticleGroup {
    return GROUP_VALUES.has(value);
}

export function isArticleLocale(value: string): value is EArticleLocale {
    return LOCALE_VALUES.has(value);
}
